import { Tooltip as MuiTooltip } from '@mui/material';

export default MuiTooltip;
